module.exports = __webpack_public_path__ + "c00b86926c1643b2f389df95d000d68b.svg";